export enum MessageStep {
  UNSET_MESSAGE_STEP_TYPE = 'UNSET_MESSAGE_STEP_TYPE', // Do not use, needed because of proto3 limitations
  CONVERSION = 'CONVERSION',
  IMPRESSION = 'IMPRESSION',
}
